module.exports = __webpack_public_path__ + "img/airbase-stage_3.5.f1090e9c.jpg";